import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  selectedUser: {},
  showUserDrawer: false,
  showDeleteUserModal: false,
  showCancelUserDrawer: false,
};

const userDrawerSlice = createSlice({
  name: 'userDrawer',
  initialState,
  reducers: {
    setSelectedUser: (state, { payload }) => {
      state.selectedUser = payload;
    },
    setShowUserDrawer: (state, { payload }) => {
      state.showUserDrawer = payload;
    },
    setShowDeleteUserModal: (state, { payload }) => {
      state.showDeleteUserModal = payload;
    },
    setShowCancelUserDrawer: (state, { payload }) => {
      state.showCancelUserDrawer = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: userDrawerReducer } = userDrawerSlice;
export const { setShowUserDrawer, setSelectedUser, setShowDeleteUserModal, setShowCancelUserDrawer } = userDrawerSlice.actions;
